import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { InvoiceConceptModel } from 'src/app/models/invoicing/invoice-concept.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { FilterGlobalResponseModel } from 'src/app/models/responses/filter-global-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChargeAccountConceptService {

  constructor(private _httpClient: HttpClient) { }

  getChargeAccountConceptById(chargeAccountConceptId: number): Observable<InvoiceConceptModel> {
    return this._httpClient.get<InvoiceConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountConcept.GetChargeAccountConceptById}/${chargeAccountConceptId}`);
  }

  getChargeAccountConceptsByChargeAccountId(chargeAccountId: number): Observable<Array<InvoiceConceptModel>> {
    return this._httpClient.get<Array<InvoiceConceptModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountConcept.GetChargeAccountConceptsByChargeAccountId}/${chargeAccountId}`);
  }

  saveGeneralDiscount(chargeAccountConceptContract: InvoiceConceptModel): Observable<InvoiceConceptModel> {
    return this._httpClient.post<InvoiceConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountConcept.SaveGeneralDiscount}`,
      chargeAccountConceptContract);
  }

  getColumnsForConceptConsultation(): Observable<FilterGlobalResponseModel> {
    return this._httpClient.get<FilterGlobalResponseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountConcept.GetColumnsForConceptConsultation}`);
  }

  getColumnsForChargeAccountDiscountConceptAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountConcept.GetColumnsForChargeAccountDiscountConceptAsync}`);
  }

  getAllChargeAccountConceptsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, storeConsolidated: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('storeConsolidated', storeConsolidated);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountConcept.GetAllChargeAccountConceptsWithPagination}`,
      filters, { params: params }
    );
  }

  exportConceptConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean, storeConsolidated: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString())
      .set('storeConsolidated', storeConsolidated);
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountConcept.ExportConceptConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getChargeAccountConceptsByChargeAccountIdWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, chargeAccountId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('chargeAccountId', chargeAccountId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountConcept.GetChargeAccountConceptsByChargeAccountIdWithPagination}`,
      { params: params }
    );
  }
}
